export default __webpack_public_path__ + "static/decorativeedge-8f4d5d496ba2c40c553319953aeaf105.png";